import { IClientConfigProperty } from 'APP/model/auth/authModel.types';
import Entities from 'STORE';
import { ClientConfigStoreKey } from 'STORE/ClientConfig/ClientConfig';

export function handleSupportEmail({ value }: IClientConfigProperty): void {
  Entities.clientConfig.setConfig(ClientConfigStoreKey.SupportEmailKey, value);
}
